export default __webpack_public_path__ + "static/media/import-csv-example-fi.6504eef8.csv";